module.exports = __webpack_public_path__ + "static/media/pattern_design_icon.7bc51a59.png";